module.exports = __webpack_public_path__ + "static/demo-bcf73fee969d293e417366e4ddf78c91.mp3";